import type { StatusChipProps } from '@components/v2/ui/StatusChip/StatusChip';
import {
  InReviewDot,
  OfflineDot,
  RejectedDot,
} from '@components/v2/ui/StatusChip/components/statusIcon.icons';
import LangEnum from '../../../../lang/LangEnum';
import { OfflineStatus } from '../../../offline/domain/offlineOrder/offlineOrder.types';

export const ORDER_OFFLINE_STATUS_CHIP_CONFIG: Record<
  OfflineStatus,
  Omit<StatusChipProps, 'size'>
> = {
  [OfflineStatus.OFFLINE]: {
    label: LangEnum.GLOBAL_OFFLINE,
    icon: OfflineDot,
    color: 'neutral',
  },
  [OfflineStatus.SYNCING]: {
    label: LangEnum.GLOBAL_SYNCING,
    icon: InReviewDot,
    color: 'waiting',
  },
  [OfflineStatus.ERROR_SYNCING]: {
    label: LangEnum.GLOBAL_ERROR,
    icon: RejectedDot,
    color: 'error',
  },
};
